module.exports = __webpack_public_path__ + "img/invitationCodeIcon.8dff354b.svg";